import { render } from "./EditGlobalScript.vue?vue&type=template&id=f04cf036"
import script from "./EditGlobalScript.vue?vue&type=script&lang=js"
export * from "./EditGlobalScript.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__